// @flow
import { useCallback, useContext } from 'react';
import * as csx from 'csstips';
import classify from '@src/utils/typestyle';

import { BandStateContext } from '@contexts/band';
import { trackAddToCart } from '../../../utils/googleAnalytics';

import * as routes from '@src/app_routes/cart';

import type { TBandDetail } from '@types/band';

type TProps = {
  ringSize: string
};

const classes = classify({
  buttonContainer: {
    position: 'relative',
    display: 'inline-block'
  },
  button: {
    ...csx.horizontal,
    ...csx.centerJustified,
    ...csx.center,
    height: '40px',
    padding: '0 20px',
    fontSize: '14px',
    lineHeight: '22px',
    fontFamily: '"acumin-pro", Arial, Helvetica, sans-serif',
    fontDisplay: 'swap',
    fontWeight: 600,
    width: '100%',
    '&:hover': {
      color: 'white'
    }
  },
  form: {
    width: '100%'
  }
});

function AddToShoppingBagButton({ ringSize }: TProps) {
  const { band }: { band: TBandDetail } = useContext(BandStateContext);

  const handleSubmitClick = useCallback(
    e => {
      e.preventDefault();

      if (ringSize) {
        trackAddToCart(band);
        e.currentTarget.submit();
      } else {
        if (window) {
          window.alert(
            'Please select a band size before you add the band to the shopping bag'
          );
        }
      }
    },
    [ringSize]
  );

  const { vendor_sku: settingSku } = band;

  if (settingSku) {
    return (
      <div className={classes.buttonContainer}>
        <form action={routes.addItem} method='POST' className={classes.form} onSubmit={handleSubmitClick}>
          <input
            type='hidden'
            name='authenticity_token'
            value={
              typeof document !== 'undefined' &&
              ReactOnRails.authenticityToken()
            }
          />
          <input type='hidden' name='item_type' value='band' />
          <input type='hidden' name='id' value={settingSku} />
          <input type='hidden' name='ring_size' value={ringSize || ''} />
          <button
            type='submit'
            className={classes.button}
          >
            Add to Shopping Bag
          </button>
        </form>
      </div>
    );
  } else {
    return null;
  }
}

export default AddToShoppingBagButton;
